import React from 'react'
import { Outlet } from 'react-router-dom'

export const UserBase: React.FC = () => {
  return <Outlet />
}
